import { appBaseUrl, appResponseApi } from "../../config/apiConfig";
import type {
  ChatCompletionResponseObject,
  TChatCompletionRequest,
} from "../completionsApi/types";
import type { TResponseApiRequestBody } from "./types/request";
import type {
  TResponseApiResponseBody,
  TResponseThread,
  TResponseThreadRun,
} from "./types/response";

export const postMessageToResponse = (
  postObj: TResponseApiRequestBody,
  options?: { signal?: AbortSignal },
): Promise<TResponseApiResponseBody> => {
  return appResponseApi
    .post("/v1/responses", postObj, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const postMessageToResponseWithProxy = (
  postObj: TResponseApiRequestBody,
  options?: { signal?: AbortSignal },
): Promise<TResponseApiResponseBody> => {
  return appBaseUrl
    .post("common_agents/v1/responses", postObj, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const postMessageToCompletion = (
  postObj: TChatCompletionRequest,
  options?: { signal?: AbortSignal },
): Promise<ChatCompletionResponseObject> => {
  return appResponseApi
    .post("/v1/chat/completions", postObj, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const getTheadList = (options?: { signal?: AbortSignal }) => {
  return appResponseApi
    .get("/v1/threads", {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const getMessagesFromThread = (
  thread_ref: string,
  options?: { signal?: AbortSignal },
): Promise<TResponseThread> => {
  return appResponseApi
    .get(`/v1/threads/${thread_ref}`, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const getMessagesFromThreadWithProxy = (
  thread_ref: string,
  options?: { signal?: AbortSignal },
): Promise<TResponseThread> => {
  return appBaseUrl
    .get(`common_agents/v1/threads/${thread_ref}`, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const getThreadRun = (
  thread_ref: string,
  options?: { signal?: AbortSignal },
): Promise<TResponseThreadRun> => {
  return appResponseApi
    .get(`/v1/threads/${thread_ref}/run`, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const deleteThread = (
  thread_ref: string,
  options?: { signal?: AbortSignal },
) => {
  return appResponseApi
    .delete(`/v1/threads/${thread_ref}`, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};

export const deleteThreadWithProxy = (
  thread_ref: string,
  options?: { signal?: AbortSignal },
) => {
  return appBaseUrl
    .delete(`common_agents/v1/threads/${thread_ref}`, {
      withCredentials: false,
      signal: options?.signal,
    })
    .then((res) => res.data);
};
